import uuid from 'uuid/v4';
import axios from 'axios';

export default function fetch(url, options = {}) {
  const addedOptions = {};

  if (url[0] === '/') {
    addedOptions.credentials = 'same-origin';
  }

  const headers = options.headers || {};
  if (options.method && (options.method.toUpperCase() === 'POST' || options.method.toUpperCase() === 'PUT')) {
    headers['Content-Type'] = 'application/json';
  }

  const fetcher = window.fetch || global.fetch;

  return fetcher(url, {
    ...options,
    headers,
    ...addedOptions,
  });
}

export function muleSoftFetch(url, method, data, option, isMediaForm) {
  const authToken = sessionStorage.getItem('token') || '';

  const defaultHeaders = {
    'x-axahk-msgid': uuid(),
    Authorization: `Bearer ${authToken}`,
  };
  if (!isMediaForm) {
    defaultHeaders['Content-Type'] = 'application/json';
  }
  let headers = defaultHeaders;
  try {
    if (option && typeof option.headers === 'object') {
      headers = {
        ...option.headers,
        ...defaultHeaders,
      };
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  if (method !== 'get') {
    return axios[method || 'get'](url, data, { ...option, headers });
  }
  return axios.get(url, { ...option, headers });
}
